import createEnum from 'scripts/lib/create_enum';

export default createEnum(
  'ADMIN',
  'ASSIGNED_CONVERSATION',
  'ASSIGNED_TASK',
  'AUTO_ACCEPTED_SESSION_NOTIFICATION',
  'DECLINED_REASSIGNED_SESSION',
  'DISCONNECT',
  'ERROR',
  'INCOMING_CONCURRENT_MESSAGE',
  'INCOMING_CONCURRENT_SESSION',
  'MANDATORY_UPGRADE',
  'OFFERED_CALL',
  'OFFERED_WARM_TRANSFER',
  'OPTIONAL_RELOAD',
  'OPTIONAL_UPGRADE',
  'SUCCESS',
  'UNOFFERED_CALL',
  'UNOFFERED_WARM_TRANSFER'
);



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/notification_type.js